<template>
    <v-layout>
        <h1 class="display-1 text-center">404</h1>
        <p class="lead text-center">Seite nicht gefunden</p>
        <br>
        <div class="text-center">
            <b-link :to="{ name: 'home.index' }">Gehe zurück zur Startseite</b-link>
        </div>
    </v-layout>
</template>

<script>
import VLayout from '@/layouts/Minimal';

export default {
  name: 'page-404',
  metaInfo() {
    return {
      title: '404 - Seite nicht gefunden',
    };
  },
  data() {
    return {};
  },
  components: {
    VLayout,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Errors/404.vue